import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App" }
const _hoisted_2 = { class: "App__navigation" }
const _hoisted_3 = { class: "App__main" }

import Navigation from "@/components/general/Navigation.vue";
import { useUiStore } from "@/stores/ui";
import Breadcrumbs from "@/components/general/breadcrumbs/Breadcrumbs.vue";
import AccessLayer from "@/components/general/access-layer/AccessLayer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const uiStore = useUiStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccessLayer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Navigation),
          _createVNode(Breadcrumbs)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(uiStore).snackbar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(uiStore).snackbar) = $event)),
      timeout: 2000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(uiStore).snackbarMessage), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})